const FullPageSpinner = () => {
  return (
    <div className="position-absolute top-50 start-50 vh-100 d-flex align-items-center justify-content-center">
      <span className="text-primary font-size-24">
        <i className="bx bx-loader bx-spin align-middle me-2" />
        {/* Loading */}
      </span>
    </div>
  );
};

export default FullPageSpinner;
